module.exports = __webpack_public_path__ + "static/media/page102_05.f2e6a540.jpg";